import { IVideoAccelData } from "@interfaces/IVideo";
import * as angular from "angular";
import { ProductVendor } from "../../videos/enums/CameraProductType";
import { IVideoAccelerometerData } from "../../videos/models/IVideoAccelerometerData";
import { CameraEventThresholds } from "../../videos/models/camera-event-thresholds";
import { CameraService } from "../../videos/services/camera.service";
import "./gForceGauge.scss";

export interface IGForceGaugeDirectiveScope extends ng.IScope {
    currentAccelData?: IVideoAccelData;
    cameraType?: ProductVendor;
}

export class GForceGaugeComponentController implements angular.IComponentController, angular.IOnChanges {

    accelDataMaxG = 1;

    accelDataLatG: number;
    accelDataLongG: number;
    accelDataVertG: number;

    accelDataLatGPercentage: number;
    accelDataLongGPercentage: number;
    accelDataVertGPercentage: number;

    // for IT cameras these are swapped
    swapLatLng = true;

    currentAccelData: IVideoAccelerometerData;
    cameraType: ProductVendor;
    thresholds: CameraEventThresholds;

    static $inject = ["cameraService"];

    constructor(private readonly cameraService: CameraService) {
    }

    $onInit(): void {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (this.currentAccelData) {
            this.updateGForce();
        }

        if (onChangesObj["cameraType"]) {
            this.thresholds = this.cameraService.getCameraThresholds();
        }
    }

    updateGForce() {
        this.accelDataLatG = this.currentAccelData.X;
        this.accelDataLongG = this.currentAccelData.Y;
        this.accelDataVertG = this.currentAccelData.Z - 1; // -1 to account for gravity

        this.accelDataLatG = this.capNumberToBounds(this.accelDataLatG, this.accelDataMaxG);
        this.accelDataLongG = this.capNumberToBounds(this.accelDataLongG, this.accelDataMaxG);
        this.accelDataVertG = this.capNumberToBounds(this.accelDataVertG, this.accelDataMaxG);

        this.accelDataLatGPercentage = this.convertToRadialCoordinates(this.accelDataLatG, this.accelDataLongG);
        this.accelDataLongGPercentage = this.convertToRadialCoordinates(this.accelDataLongG, this.accelDataLatG);

        this.accelDataLatGPercentage = this.convertGToPercentageOfMax(this.accelDataLatG);
        this.accelDataLongGPercentage = this.convertGToPercentageOfMax(this.accelDataLongG);
        this.accelDataVertGPercentage = this.convertGToPercentageOfMax(this.accelDataVertG);
    }

    // ---

    private capNumberToBounds(number: number, maxValue: number) {
        var capped = Math.min(number, this.accelDataMaxG);
        capped = Math.max(capped, -this.accelDataMaxG);

        return capped;
    }

    private convertGToPercentageOfMax(g: number) {

        // Ensure we cap both ways as the number could be positive or negative

        var maxOverallG = this.accelDataMaxG * 2;

        var gPercentage = (g + this.accelDataMaxG) * 100 / maxOverallG;

        return gPercentage;
    }

    private convertToRadialCoordinates(number1: number, number2: number) {
        return number1 * Math.sqrt(1 - 0.5 * Math.pow(number2, 2));
    }
}

export class GForceGaugeComponent implements angular.IComponentOptions {

    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            currentAccelData: "<",
            cameraType: "<"
        };

        this.controller = GForceGaugeComponentController;
        this.template = require("./gForceGauge.template.html");
    }
}
